export const firebaseConfig = {
  apiKey: 'AIzaSyAMvwjK77NBPdfd-5xl7OqHbWqjxfR6rEM',
  authDomain: 'investing-development.firebaseapp.com',
  databaseURL: 'https://investing-development.firebaseio.com',
  projectId: 'investing-development',
  storageBucket: 'investing-development.appspot.com',
  messagingSenderId: '387935497785',
  appId: '1:387935497785:web:64478c4129f8ef057aa7e8'
}
